import { apiUrl } from '../../apis/session-refresh';

export const EXPORT_PATH = '/simulator/estimates/export';

export const EXPORT_FILE_NAME = 'Depreciation Simulator Export.xlsx';

/** Fetches the workbook the service builds from every saved estimate and hands it to the browser as a download. */
export const downloadSimulatorExport = async (): Promise<void> => {
  const response = await fetch(apiUrl(EXPORT_PATH));

  if (!response.ok) {
    throw new Error(`The export could not be built (${response.status}).`);
  }

  const url = URL.createObjectURL(await response.blob());
  const anchor = document.createElement('a');

  anchor.href = url;
  anchor.download = EXPORT_FILE_NAME;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1_000);
};
